export const formatSlugToTitleCase = (slug: string): string => {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const toKebabCase = (str?: string): string => {
  if (!str) return "";

  return str
    .normalize("NFKC")
    .replace(/\+/g, " plus") // Replace '+' with ' plus'
    .replace(/[^\w\s-]/g, "") // Remove non-word characters except space and dash
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "-"); // Collapse spaces/dashes into single dash
};

export const cleanAndMatchTyrePattern = (
  tireSize: string
): RegExpMatchArray | null => {
  const cleanSize = tireSize
    .trim()
    .replace(/\(.*?\)/g, "")
    .trim() // Remove anything inside brackets
    .replace(/['"]/g, "")
    .replace(/\s*\/\s*/g, "/")
    .replace(/\/([A-Z])/i, " $1");

  // Pattern to match both "255/40 R21", "R19" and "40 R21" formats
  const pattern = /^(?:(\d+)\/)?(?:(\d+)\s+)?([A-Z])\s*(\d+)$/i;
  return cleanSize.match(pattern);
};
export const cleanString = (val: any): string => {
  if (val === undefined || val === "undefined") return "";
  // Remove all single and double quotes
  return String(val).replace(/['"]/g, "").replace(/[“”]/g, "");
};
// Check if quote has valid data
export const isUndefinedValue = (value: string | undefined | null): boolean => {
  const s = value ? cleanString(value) : "";
  // Scenario 1: Check if the value is the actual JavaScript `undefined` primitive.
  if (s === undefined) {
    return true;
  }

  // Scenario 2: Check if the value is a string "undefined".
  // We ensure it's a string first to avoid errors if value is not a string.
  if (
    typeof s === "string" &&
    (s === '"undefined"' || s === "undefined" || s === "")
  ) {
    return true;
  }

  // If neither of the above conditions are met, it's not an "undefined" quote.
  return false;
};

export const getCurrencyWithLakh = (value: number): string => {
  if (value === undefined || value === null) return "";
  const lakhs = value / 100000;
  return `₹${lakhs.toFixed(1)} L`;
};

export const formatToTitleCase = (text: string): string => {
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const capitalizeFirst = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
